export default __webpack_public_path__ + "static/media/9.6c9e7719.jpg";